import React, { useContext, useState } from 'react';

const AppContext = React.createContext();

const AppAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const saveUser = (user) => {
    setUser(user);
  };

  const removeUser = () => {
    setUser(null);
  };

  return (
    <AppContext.Provider value={{ saveUser, removeUser, user }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAuthContext = () => {
  return useContext(AppContext);
};

export { AppAuthProvider };
